export default "/fonts/UkNumberPlate.ttf?22e2b53e5bb126678eb4bd5f0fe71444";